import React, { FC, useState, useEffect } from 'react';
import shuffle from 'lodash/shuffle';
import { useWindowSize } from '@react-hook/window-size';

import { Device } from 'components/Device';
import { SeamlessPlayer } from 'artworkPlayer';

type Props = {
  onDecorationLoaded: () => void;
};

const ARTWORK_IDS =
  process.env.NODE_ENV === 'development'
    ? [21, 21]
    : shuffle([
      100079,
      106341,
      100105,
      105984,
      106346,
      106087,
      105988,
      105914,
      106602,
      106751,
      104015,
      107181,
    ]);

const TV_IMAGE_RATIO = 1316 / 814;

export const Decoration: FC<Props> = ({ onDecorationLoaded }: Props) => {
  const [windowWidth, windowHeight] = useWindowSize();
  const [scaledTVWidth, setScaledTVWidth] = useState<number>((windowHeight * 0.5) * TV_IMAGE_RATIO);

  const [showTV, setShowTV] = useState<boolean>(
    windowHeight > 460 && windowWidth >= (scaledTVWidth * 1.62),
  );

  useEffect(() => {
    const width = (windowHeight * 0.5) * TV_IMAGE_RATIO;

    setShowTV(windowHeight > 460 && windowWidth >= (width * 1.62));
    
    setScaledTVWidth(width);
  }, [windowHeight, windowWidth]);

  useEffect(() => {
    if (!showTV) {
      onDecorationLoaded();
    }
  }, [onDecorationLoaded, showTV]);

  return (
    <Device
      type='lg-tv'
      style={{
        width: `${(scaledTVWidth)}px`,
        position: 'fixed',
        right: 0,
        top: '50%',
        transform: `translate(${100 / (windowWidth / scaledTVWidth)}%, calc(-50% - 40px))`,
        display: showTV ? 'block' : 'none',
      }}
    >
      <div className='stretch' style={{ backgroundColor: '#111116' }}>
        <SeamlessPlayer
          className='stretch'
          artworkIds={ARTWORK_IDS}
          onPlaybackAttempted={onDecorationLoaded}
        />
        <div
          className='stretch'
          style={{ backgroundColor: 'rgba(0, 0, 0, 0.01)' }}
        />
      </div>
    </Device>
  );
};
